/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReorderClassificationItemsInputFromJSON, ApiReorderClassificationItemsInputToJSON, } from './ApiReorderClassificationItemsInput';
export function ApiReorderClassificationItemsPayloadFromJSON(json) {
    return ApiReorderClassificationItemsPayloadFromJSONTyped(json, false);
}
export function ApiReorderClassificationItemsPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'input': !exists(json, 'input') ? undefined : (json['input'].map(ApiReorderClassificationItemsInputFromJSON)),
    };
}
export function ApiReorderClassificationItemsPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'input': value.input === undefined ? undefined : (value.input.map(ApiReorderClassificationItemsInputToJSON)),
    };
}
